(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["penny-bundle-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pennyAddInit) return;
    window.__pennyAddInit = true;
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest && e.target.closest('[data-penny-add]');
      if (!btn) return;
      e.preventDefault();
      var err = btn.parentElement.querySelector('[data-penny-add-error]');
      if (err) err.hidden = true;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1, properties: { _personalize_pending: '1' } }] })
        });
        if (!res.ok) throw new Error('add');
        if (location.pathname.replace(/\/$/, '') === '/cart') {
          location.reload();
        } else {
          location.href = '/cart';
        }
      } catch (x) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        if (err) { err.textContent = 'Could not add it. Please try again.'; err.hidden = false; }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["penny-finish-personalization"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pennyFinishInit) return;
    window.__pennyFinishInit = true;

    function pendingCount() {
      var n = 0;
      document.querySelectorAll('[data-penny-pending]').forEach(function (el) {
        n = Math.max(n, parseInt(el.getAttribute('data-penny-pending'), 10) || 0);
      });
      return n;
    }

    document.addEventListener('submit', async function (e) {
      var form = e.target.closest && e.target.closest('[data-penny-form]');
      if (!form) return;
      e.preventDefault();
      var err = form.querySelector('[data-error]');
      var btn = form.querySelector('.penny-finish__save');
      var props = {};
      err.hidden = true;

      if (form.dataset.kind === 'heart') {
        var charm = form.querySelector('[data-charm]').value.trim();
        if (!charm) {
          err.textContent = 'Enter the heart charm text (up to 5 characters).';
          err.hidden = false;
          return;
        }
        props['Heart charm'] = charm;

        // The entry must hold exactly one initial + year pair per selected penny.
        var pennies = form.querySelector('[data-pennies-text]').value.trim().toUpperCase();
        var need = parseInt(form.querySelector('[data-opt2]').value, 10) || 1;
        var pair = /([A-Za-z]{1,2})\s*[-:.]?\s*((?:19|20)\d{2})/g;
        var found = (pennies.match(pair) || []).length;
        var rest = pennies.replace(pair, ' ').replace(/\band\b/gi, ' ');
        if (found !== need || !/^[\s,;&\/\-–.]*$/.test(rest)) {
          err.textContent = 'Please enter ' + need + ' initial' + (need > 1 ? 's' : '') + ' and year' + (need > 1 ? 's' : '') + ', one for each penny. Example: A 1990' + (need > 1 ? ', J 1992' : '') + '.';
          err.hidden = false;
          return;
        }
        props['Initials and years'] = pennies;
      } else {
        var ok = true;
        form.querySelectorAll('[data-prop]').forEach(function (inp) {
          var v = inp.value.trim();
          if (!v) ok = false;
          props[inp.dataset.prop] = v;
        });
        if (!ok) {
          err.textContent = 'Please fill in both names and the date.';
          err.hidden = false;
          return;
        }
      }

      var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
      var o1 = form.querySelector('[data-opt1]').value;
      var o2El = form.querySelector('[data-opt2]');
      var o2 = o2El ? o2El.value : null;
      var match = variants.find(function (v) { return v.o1 === o1 && (o2 === null || v.o2 === o2); });
      if (!match) {
        err.textContent = 'That combination is not available. Please change your choices.';
        err.hidden = false;
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Saving…';
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        var qty = parseInt(form.dataset.qty, 10) || 1;
        var r1 = await fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: match.id, quantity: qty, properties: props }] }) });
        if (!r1.ok) throw new Error('add');
        var r2 = await fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: form.dataset.key, quantity: 0 }) });
        if (!r2.ok) throw new Error('remove');
        window.location.reload();
      } catch (x) {
        btn.disabled = false;
        btn.textContent = 'Save personalization';
        err.textContent = 'Could not save. Please try again.';
        err.hidden = false;
      }
    });

    // Checkout guard: block checkout while a keychain still needs personalization.
    document.addEventListener('click', function (e) {
      if (pendingCount() === 0) return;
      var t = e.target.closest && e.target.closest('a, button, input[type="submit"]');
      if (!t || t.closest('[data-penny-form]')) return;
      var label = (t.textContent || t.value || '') + ' ' + (t.getAttribute('name') || '') + ' ' + (t.getAttribute('href') || '');
      if (!/check\s?out|\/checkouts?/i.test(label)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var panel = document.querySelector('.penny-finish:not(.penny-finish--compact)');
      if (panel) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.location.href = '/cart';
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
